import {MRootButton} from "@ui/buttons/RootButton";
import {motion} from "framer-motion";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

const textAnimation = {
  hidden: {
    opacity: 0,
    y: -150,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.3,
      duration: 0.3,
    },
  },
};

const buttonAnimation = {
  hidden: {
    y: 150,
  },
  visible: {
    y: 0,
    transition: {
      delay: 0.3,
      duration: 0.3,
    },
  },
};

export const Try = ({title, onClickBtn, button, size = 44}) => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const {t} = useTranslation();

  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      viewport={{amount: 0.7, once: true}}
      className={styles.try}
    >
      <motion.h4
        variants={textAnimation}
        style={!isMobile ? {fontSize: `${size}rem`} : {fontSize: "26rem"}}
      >
        {title}
      </motion.h4>

      <MRootButton
        variants={buttonAnimation}
        txt={button || t("button.block_try")}
        onClick={onClickBtn}
      />
    </motion.div>
  );
};
